// extracted by mini-css-extract-plugin
export default {"button":"SvgButton_button__sML2d","button_wrapper":"SvgButton_button_wrapper__q1+0p","button_disabled":"SvgButton_button_disabled__9Wu6j","icon":"SvgButton_icon__TbGq3"};